export interface IAppSettings {
  readonly apiUrl: string;
  readonly snapshotBucket: string;
  readonly authConfig: AuthConfig;
  readonly cloudWatchRumConfig: CloudWatchRumConfig;
  readonly region: string;
}

interface AuthConfig {
  readonly assumeRoleArn: string;
  readonly identityPoolId: string;
  readonly userPoolId: string;
  readonly userPoolWebClientId: string;
  readonly userPoolDomainUrl: string;
}

interface CloudWatchRumConfig {
  readonly cfnMonitorAppId: string;
  readonly sessionSampleRate: string;
  readonly telemetries: string;
  readonly allowCookies: string;
  readonly enableXRay: string;
  readonly endpoint: string;
}

let cache: IAppSettings = {
  apiUrl: "",
  snapshotBucket: "",
  authConfig: {
    assumeRoleArn: "",
    identityPoolId: "",
    userPoolId: "",
    userPoolWebClientId: "",
    userPoolDomainUrl: "",
  },
  cloudWatchRumConfig: {
    cfnMonitorAppId: "",
    sessionSampleRate: "",
    telemetries: "",
    allowCookies: "",
    enableXRay: "",
    endpoint: "",
  },
  region: "",
};

let initialized = false;

// This needs to be a function. If declared as constant, the cache stays with empty values
export const AppSettings = (): IAppSettings => cache;

function initializeAppSettings(settings: IAppSettings) {
  initialized = true;
  cache = { ...settings };
  Object.freeze(cache);
}

export async function loadAppSettings() {
  if (initialized) {
    return;
  }
  // Initialize application settings
  await fetch("./settings.json")
    .then((settings) => settings.json())
    .then((json) => initializeAppSettings(json))
    .catch(() => console.error("Missing/invalid localSettings/settings.json file"));
}
